export const tokens = {
  feedFMtoken: '5d74ac0356c194c6f25c32bfc9f0c486afc7d1d0',
  feedFMsecret: 'aa0c4982f7b0f0c2d9637c3168850c2129ee9c98',
};
